import { render, staticRenderFns } from "./SetResolution.vue?vue&type=template&id=2fe3fed9&scoped=true&"
import script from "./SetResolution.vue?vue&type=script&lang=js&"
export * from "./SetResolution.vue?vue&type=script&lang=js&"
import style0 from "./SetResolution.vue?vue&type=style&index=0&id=2fe3fed9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3fed9",
  null
  
)

export default component.exports